import { Edit, KeyOutlined, Lock, LockOpen, Person } from "@mui/icons-material";

import {
  Menu,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

interface MenuAdmProps {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  open: boolean;
  setOpenEditProfileModal?: (value: boolean) => void;
  setOpenEditLoginModal?: (value: boolean) => void;
  setOpenEditPermissionModal?: (value: boolean) => void;
  setModalAlert?: (value: boolean) => void;
}

export default function MenuAdm({
  anchorEl,
  handleClose,
  open,
  setOpenEditProfileModal = () => {},
  setOpenEditLoginModal = () => {},
  setOpenEditPermissionModal = () => {},
  setModalAlert = () => {},
}: MenuAdmProps) {
  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
      >
        <MenuList>
          <MenuItem
            color="text.secondary"
            onClick={() => {
              setOpenEditLoginModal(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Editar Senha</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setOpenEditProfileModal(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Person fontSize="small" />
            </ListItemIcon>
            <ListItemText>Editar Detalhes</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setOpenEditPermissionModal(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <KeyOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>Alterar Permissões</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
